"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontSize = exports.fontSize = {
  type: "select",
  options: [{ label: "10", value: "10px" }, { label: "12", value: "12px" }, { label: "13", value: "13px" }, { label: "14", value: "14px" }, { label: "15", value: "15px" }, { label: "16", value: "16px" }, { label: "18", value: "18px" }, { label: "20", value: "20px" }, { label: "22", value: "22px" }, { label: "24", value: "24px" }, { label: "26", value: "26px" }, { label: "28", value: "28px" }, { label: "30", value: "30px" }]
};
var textTransform = exports.textTransform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "lowercase", value: "lowercase" }]
};
var fontWeight = exports.fontWeight = {
  type: "select",
  options: [{ label: "Bold", value: "600" }, { label: "Medium", value: "400" }, { label: "Light", value: "200" }]
};
var radius = exports.radius = {
  type: "select",
  options: [{ label: "Square", value: "0%" }, { label: "Round", value: "10%" }, { label: "Circle", value: "50%" }]
};

var textAlign = exports.textAlign = {
  type: "select",
  options: [{ label: "Left", value: "left" }, { label: "Center", value: "center" }, { label: "Right", value: "right" }]
};